import { isNil } from "lodash-es";
import { safeParse } from "valibot";
import type { JSX } from "solid-js";
import type { FieldConfig } from "./types";
import { toField } from "./fields";
import type { FormVersion } from "../state/formVersion";

export const renderFieldValue = (value: unknown, fieldConfig: FieldConfig, formVersion: FormVersion): JSX.Element => {
  if (isNil(value)) {
    return;
  }

  const baseField = toField(fieldConfig.type);

  if (!isNil(baseField.renderValue) && !isNil(baseField.valueSchema)) {
    const { success, output } = safeParse(baseField.valueSchema, value);

    if (success) {
      const renderedValue = baseField.renderValue(output, { fieldConfig, formVersion });
      if (!isNil(renderedValue)) {
        return renderedValue;
      }
    } else {
      // Field data is not what we expect, most likely due to 'data name' re-use
      return JSON.stringify(value);
    }
  }

  // TODO, DEV-7425 throw when all fields have been implemented
  return JSON.stringify(value);
};

export const renderFieldValueAsString = (
  value: unknown,
  path: string[],
  fieldConfig: FieldConfig,
): string | undefined => {
  if (isNil(value)) {
    return;
  }

  const baseField = toField(fieldConfig.type);

  if (!isNil(baseField.stringValue) && !isNil(baseField.valueSchema)) {
    const { success, output } = safeParse(baseField.valueSchema, value);

    if (success) {
      const renderedValue = baseField.stringValue(output, path);
      if (!isNil(renderedValue)) {
        return renderedValue;
      }
    }
  }
};
